var _g, _path, _path2, _g2, _path3, _path4, _path5, _g3, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 26,
    viewBox: "0 0 106 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 28,
    height: 20,
    rx: 2.5,
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0547 8.8999C19.6544 8.8999 20.1379 9.03154 20.4444 9.15281L20.2334 10.4548L20.0951 10.3858C19.8076 10.2631 19.4423 10.1464 18.9346 10.1549C18.3263 10.1549 18.0463 10.4221 18.046 10.6712C18.0409 10.9536 18.3752 11.1381 18.9158 11.4164C19.8114 11.8448 20.2257 12.3635 20.2192 13.0486C20.2066 14.2937 19.1473 15.0999 17.5193 15.0999C16.823 15.0924 16.1534 14.9472 15.7904 14.7801L16.0076 13.4358L16.2088 13.5316C16.7172 13.755 17.0474 13.8454 17.6673 13.8454C18.1123 13.8454 18.5907 13.6621 18.5966 13.2597C18.5985 12.9968 18.3963 12.8084 17.7907 12.5147C17.2039 12.2277 16.4233 11.7458 16.4332 10.8819C16.4426 9.71536 17.5206 8.8999 19.0547 8.8999ZM13.268 15.0111L14.2385 9.0046H15.7892L14.8182 15.0111H13.268ZM11.9669 9.0105L10.449 13.104L10.2871 12.2722C9.90908 11.2524 9.0906 10.1825 8.13745 9.74867L9.5263 15.0052L11.1677 15.0044L13.609 9.0105H11.9669ZM24.4219 9.01082H23.2238C22.8524 9.01082 22.5741 9.11679 22.41 9.5093L20.1078 15.013H21.7367C21.7367 15.013 22.0029 14.2723 22.0632 14.1099C22.1467 14.1099 22.5406 14.1108 22.958 14.1116C23.4285 14.1126 23.929 14.1136 24.0487 14.1136C24.0967 14.323 24.2375 15.013 24.2375 15.013H25.6777L24.4219 9.01082ZM23.1273 11.2024C23.1273 11.2024 22.6382 12.5367 22.5094 12.8814H23.7969C23.7347 12.5813 23.4369 11.148 23.4369 11.148L23.3335 10.6303C23.2941 10.7422 23.2405 10.8884 23.1978 11.0051C23.1546 11.1229 23.1225 11.2106 23.1273 11.2024Z",
    fill: "#FFFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06461 9H6.51478L6.5 9.10527C8.48251 9.61248 9.79048 10.8576 10.3351 12.33L9.7809 9.51581C9.68569 9.12867 9.40821 9.01365 9.06461 9Z",
    fill: "#E79F3F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 4.5C39 3.11929 40.1193 2 41.5 2H64.5C65.8807 2 67 3.11929 67 4.5V19.5C67 20.8807 65.8807 22 64.5 22H41.5C40.1193 22 39 20.8807 39 19.5V4.5Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 4.5C39.5 3.39543 40.3954 2.5 41.5 2.5H64.5C65.6046 2.5 66.5 3.39543 66.5 4.5V19.5C66.5 20.6046 65.6046 21.5 64.5 21.5H41.5C40.3954 21.5 39.5 20.6046 39.5 19.5V4.5Z",
    stroke: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 17C52.7614 17 55 14.7614 55 12C55 9.23858 52.7614 7 50 7C47.2386 7 45 9.23858 45 12C45 14.7614 47.2386 17 50 17Z",
    fill: "#CB494A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 17C58.7614 17 61 14.7614 61 12C61 9.23858 58.7614 7 56 7C53.2386 7 51 9.23858 51 12C51 14.7614 53.2386 17 56 17Z",
    fill: "#FEB459"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 7.99951C51.7856 8.91172 51 10.3641 51 11.9999C51 13.6357 51.7856 15.088 53 16.0002C54.2144 15.088 55 13.6357 55 11.9999C55 10.3641 54.2144 8.91172 53 7.99951Z",
    fill: "#CB494A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddi)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 8.4C75 6.15979 75 5.03969 75.436 4.18404C75.8195 3.43139 76.4314 2.81947 77.184 2.43597C78.0397 2 79.1598 2 81.4 2H96.6C98.8402 2 99.9603 2 100.816 2.43597C101.569 2.81947 102.181 3.43139 102.564 4.18404C103 5.03969 103 6.15979 103 8.4V15.6C103 17.8402 103 18.9603 102.564 19.816C102.181 20.5686 101.569 21.1805 100.816 21.564C99.9603 22 98.8402 22 96.6 22H81.4C79.1598 22 78.0397 22 77.184 21.564C76.4314 21.1805 75.8195 20.5686 75.436 19.816C75 18.9603 75 17.8402 75 15.6V8.4Z",
    fill: "#3498D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 8.4C75 6.15979 75 5.03969 75.436 4.18404C75.8195 3.43139 76.4314 2.81947 77.184 2.43597C78.0397 2 79.1598 2 81.4 2H96.6C98.8402 2 99.9603 2 100.816 2.43597C101.569 2.81947 102.181 3.43139 102.564 4.18404C103 5.03969 103 6.15979 103 8.4V15.6C103 17.8402 103 18.9603 102.564 19.816C102.181 20.5686 101.569 21.1805 100.816 21.564C99.9603 22 98.8402 22 96.6 22H81.4C79.1598 22 78.0397 22 77.184 21.564C76.4314 21.1805 75.8195 20.5686 75.436 19.816C75 18.9603 75 17.8402 75 15.6V8.4Z",
    fill: "url(#paint2_linear)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5 8.4C75.5 7.27164 75.5004 6.45545 75.5528 5.81352C75.6048 5.17744 75.7054 4.75662 75.8815 4.41103C76.217 3.75247 76.7525 3.21703 77.411 2.88148C77.7566 2.70539 78.1774 2.60481 78.8135 2.55284C79.4554 2.50039 80.2716 2.5 81.4 2.5H96.6C97.7284 2.5 98.5446 2.50039 99.1865 2.55284C99.8226 2.60481 100.243 2.70539 100.589 2.88148C101.248 3.21703 101.783 3.75247 102.119 4.41103C102.295 4.75662 102.395 5.17744 102.447 5.81352C102.5 6.45545 102.5 7.27164 102.5 8.4V15.6C102.5 16.7284 102.5 17.5446 102.447 18.1865C102.395 18.8226 102.295 19.2434 102.119 19.589C101.783 20.2475 101.248 20.783 100.589 21.1185C100.243 21.2946 99.8226 21.3952 99.1865 21.4472C98.5446 21.4996 97.7284 21.5 96.6 21.5H81.4C80.2716 21.5 79.4554 21.4996 78.8135 21.4472C78.1774 21.3952 77.7566 21.2946 77.411 21.1185C76.7525 20.783 76.217 20.2475 75.8815 19.589C75.7054 19.2434 75.6048 18.8226 75.5528 18.1865C75.5004 17.5446 75.5 16.7284 75.5 15.6V8.4Z",
    stroke: "black",
    strokeOpacity: 0.04
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9119 11.7143H83.1379L82.5249 10.2857L81.9119 11.7143ZM99 9H95.8582L95.092 9.78571L94.4023 9H87.7356L87.1226 10.2857L86.5096 9H83.8276V9.57143L83.5211 9H81.2222L79 14H81.682L81.9885 13.2143H82.7548L83.0613 14H86.0498V13.4286L86.2797 14H87.8123L88.0421 13.3571V14H94.1724L94.9387 13.2143L95.6284 14H98.7701L96.7778 11.5L99 9ZM89.728 13.2857H88.8851V10.5L87.5824 13.2857H86.8161L85.5134 10.5V13.2857H83.751L83.4444 12.5H81.6054L81.2989 13.2857H80.3027L81.9119 9.71429H83.2146L84.6705 13.0714V9.71429H86.1264L87.2759 12.1429L88.3487 9.71429H89.8046V13.2857H89.728ZM97.3142 13.2857H96.1648L95.1686 12.0714L94.0192 13.2857H90.5709V9.71429H94.0958L95.1686 10.8571L96.318 9.71429H97.3908L95.705 11.5L97.3142 13.2857ZM91.4138 10.4286V11.0714H93.3295V11.7857H91.4138V12.5H93.5594L94.5556 11.4286L93.636 10.4286H91.4138Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 34,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd",
    x: 36,
    y: 0,
    width: 34,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddi",
    x: 72,
    y: 0,
    width: 34,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3,
    y1: 2,
    x2: 3,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F558C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 39,
    y1: 2,
    x2: 39,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 85.2308,
    y1: 3.57895,
    x2: 100.456,
    y2: 20.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.714afb640dcb4854aae5ec1c763d6d97.svg";
export { ForwardRef as ReactComponent };